import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';

@Injectable()
export class BaseWrapperService extends BaseApiService {
    public simpleGet(path: string): Observable<any> {
        return this.get(path);
    }
}
